import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import {
  catalogBibShape,
  libraryShape,
  listShape,
  userIdentityShape,
  paginationShape
} from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import { selectUserEntities } from 'app/selectors/EntitiesSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import {
  selectCommunityListsForCurrentBib,
  selectCommunityListsPagination
} from 'app/selectors/bibs/DiscoverySelector';

import CommunityLists from './CommunityLists';

export function CommunityListsContainer(props) {
  return <CommunityLists {...props} />;
}

CommunityListsContainer.propTypes = {
  library: libraryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  pagination: paginationShape.isRequired,
  users: ImmutablePropTypes.mapOf(userIdentityShape),
  lists: ImmutablePropTypes.listOf(listShape).isRequired
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state),
  users: selectUserEntities(state),
  lists: selectCommunityListsForCurrentBib(state),
  pagination: selectCommunityListsPagination(state),
  library: selectCurrentLibrary(state)
});

export default connect(mapStateToProps)(CommunityListsContainer);
